import React, { useState } from "react";
import cx from "classnames";
import { useRouter } from "next/router";

import useFilters from "hooks/useFilters";

import Dropdown from "components/botanic/Dropdown";
import DropdownItem from "components/botanic/Dropdown/DropdownItem";

type Props = {
  className?: string;
  onClick?: (sort: string) => void;
  sortOptions: { [key: string]: string };
  defaultOption?: number;
};

const Sort: React.FC<Props> = ({
  className,
  sortOptions,
  onClick,
  defaultOption = 0,
}) => {
  const router = useRouter();
  const currentSort = Object.keys(sortOptions).find(
    (key) => sortOptions[key] === router?.query?.sort
  );

  const [sortOption, setSortOption] = useState(
    currentSort || Object.keys(sortOptions)[defaultOption]
  );
  const { swapFilter } = useFilters();

  const handleSelectSortOption = (
    e: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    const newSortOption = e.currentTarget.innerHTML;
    const currentSortOption = sortOption;

    if (currentSortOption !== newSortOption) {
      const sort = sortOptions[newSortOption];
      swapFilter([currentSortOption], { sort });

      setSortOption(newSortOption);
      if (onClick) {
        onClick(sortOptions[newSortOption]);
      }
    }
  };

  return (
    <div className={cx("flex text-xs items-center", className)}>
      <div className="mr-xs leading-none">Sort by</div>
      <Dropdown className="items-center" selectedItem={sortOption}>
        <div className="nav-box px-sm">
          {Object.entries(sortOptions).map(([sortOption]) => (
            <DropdownItem
              className="nav-item rounded py-sm px-lg"
              key={sortOption[0]}
              onClick={(e) => handleSelectSortOption(e)}
              aria-hidden="true"
            >
              {sortOption}
            </DropdownItem>
          ))}
        </div>
      </Dropdown>
      <style jsx global>{`
        .nav-box.selected,
        .nav-item:hover {
          background-color: #e6f2f0;
        }
      `}</style>
    </div>
  );
};

export default Sort;
